import React from "react";
import { Paragraph } from "@bluecrew/web-react-core";

interface TextProps {
  text?: string;
}
export const Text = ({ text }: TextProps) =>
  text ? <Paragraph data-testid="icon-header-text">{text}</Paragraph> : null;
